<template>
  <Layout>
    <FeedbackMessage :feedback="feedback" :resetFeedback="resetFeedback" />

    <div class="max-w-7xl mx-auto my-6 px-4">
      <div class="flex justify-between mb-5">
        <GoBack text="shottracker careers" link="Careers" />
        <AdminOnly v-if="!loading.status">
          <AdminOptions
            v-if="!deleteClicked"
            @deleteClicked="deleteClicked = !deleteClicked"
            @editClicked="editClicked"
          />
          <div v-if="deleteClicked">
            <DeleteConfirmation
              @cancelDelete="deleteClicked = !deleteClicked"
              @deleteHandler="deleteHandler"
            />
          </div>
        </AdminOnly>
      </div>
      <LoadingSpinner v-if="loading.display" :message="loading.message" />
      <div v-else>
        <Title :text="file.JSON.role" />
        <div class="rounded my-10">
          <JobPostingsPreview
            data-aos="fade-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="500"
            :form="file.JSON"
          />
        </div>

        <div class="flex justify-end">
          <img :src="getImg()" alt="pdf-copy" />
          <p
            class="
              uppercase
              text-STblue
              font-bold font-AvenirBlackFont
              ml-2
              my-auto
              cursor-pointer
              underline
              hover:text-STorange
            "
            @click="openLink"
          >
            download pdf
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { generateFullPath } from "../../utils/fileHelpers";
import JobPostingsPreview from "./JobPostingsPreview.vue";
import LoadingSpinner from "../LoadingSpinner.vue";
import Title from "./Title.vue";
import GoBack from "../GoBack.vue";
import AdminOnly from "../AdminOnly.vue";
import DeleteConfirmation from "../DeleteConfirmation.vue";
import AdminOptions from "../AdminOptions.vue";
import Layout from "../Layout.vue";
import FeedbackMessage from "../FeedbackMessage.vue";
import loader from "../../mixins/loader";

export default {
  name: "JobPostingPage",
  mixins: [loader],

  components: {
    JobPostingsPreview,
    LoadingSpinner,
    Title,
    GoBack,
    AdminOptions,
    DeleteConfirmation,
    AdminOnly,
    Layout,
    FeedbackMessage,
  },

  data() {
    return {
      deleteClicked: false,
    };
  },

  computed: {
    ...mapGetters(["file", "feedback", "careersID", "dataDeleted"]),
  },

  methods: {
    ...mapActions(["fetchFile", "deleteFileFromS3", "resetFeedback"]),

    openLink() {
      window.open(this.file.pdfURL, "_blank");
    },

    getImg() {
      return generateFullPath("/themes/st2018/img/pdf-copy.png");
    },

    async deleteHandler() {
      const identifier = this.file.identifier;
      const key = this.careersID.directoryKey;
      const file = { identifier, key };

      await this.load(this.deleteFileFromS3(file), "Deleting job posting");

      if (this.dataDeleted(identifier, key)) {
        this.$router.push({
          name: "Careers",
        });
      }
    },

    editClicked() {
      this.$router.push({
        name: "EditJobPosting",
        params: { id: this.file.identifier },
      });
    },
  },

  async created() {
    const identifier = this.$route.params.id;

    await this.load(this.fetchFile(identifier), "Loading job posting");

    // if (this.file.JSON === "") {
    //   this.$router.push({
    //     name: "Careers",
    //   });
    // }
  },
};
</script>